import { Injectable, inject } from '@angular/core';
import { HisAuthService } from 'hisng';

@Injectable()
export class RightsUtils {
    private auth = inject(HisAuthService);


    public checkPublicationRights() {
        return this.auth.hasAny(
            'RIGHT_FS_RES_PUBLICATION_VIEW_PUBLICATION',
            'RIGHT_FS_RES_PUBLICATION_VIEW_PUBLICATION_OWN',
            'RIGHT_FS_RES_PUBLICATION_VIEW_PUBLICATION_BY_TYPE',
            'RIGHT_FS_RES_PUBLICATION_VIEW_PUBLICATION_VISIBLE');
    }

    public checkPublicationCommentRights() {
        return this.auth.hasAny(
            'RIGHT_FS_RES_PUBLICATION_VIEW_PUBLICATION_COMMENT',
            'RIGHT_FS_RES_PUBLICATION_VIEW_PUBLICATION_OWN');
    }

    public checkProjectRights() {
        return this.auth.hasAny(
            'RIGHT_FS_RES_PROJECT_VIEW_PROJECT',
            'RIGHT_FS_RES_PROJECT_VIEW_PROJECT_OWN',
            'RIGHT_FS_RES_PROJECT_VIEW_PROJECT_VISIBLE');
    }

    public checkPatentRights() {
        return this.auth.hasAny(
            'RIGHT_FS_RES_PATENT_VIEW_PATENT',
            'RIGHT_FS_RES_PATENT_VIEW_PATENT',
            'RIGHT_FS_RES_PATENT_VIEW_PATENT_OWN',
            'RIGHT_FS_RES_PATENT_VIEW_PATENT_VISIBLE');
    }

    public checkUnitRights() {
        return this.auth.hasAny('RIGHT_CM_EXA_COURSE_VIEW_EVENT_DATE');
    }

    public checkPatentCommentRights() {
        return this.auth.hasAny(
            'RIGHT_FS_RES_PATENT_VIEW_PATENT_COMMENT',
            'RIGHT_FS_RES_PATENT_VIEW_PATENT_OWN');
    }

    public checkViewOrgunitTreeRight() {
        return this.auth.hasAny('RIGHT_CS_PSV_ORGTREE_VIEW_ORGUNIT_TREE');
    }

}
